import { IProjectsUpsellRequestSources } from '.'

export const ProjectsUpsellRequestSources: IProjectsUpsellRequestSources = {
  flexibleTracking: 'Flexible Tracking upsell modal step',
  flexibleTrackingEmptyState: 'Flexible Tracking empty state',
  jobsAndRatesUpsellState: 'Project Jobs and Rates upsell state',
  overview: 'Project page overview upsell',
  spending: 'Project spending table upsell state',
  tasks: 'Project tasks table upsell state',
  tasksCore: 'Tasks core upsell modal',
  clients: 'Project clients table upsell state',
  contributors: 'Project contributors table upsell state',
  kanbanTasks: 'Kanban tasks upsell modal',
  clientsAndKanbanTasks: 'Clients and Kanban tasks upsell modal',
  schedule: 'Project Schedule upsell state',
  scheduleEmptyState: 'Project Schedule empty state',
  kanbanAndSchedule: 'Kanban tasks and Schedule upsell modal',
  projectSalesInvoices: 'Project sales invoices upsell modal',
  projectQuotes: 'Project quotes upsell modal',
  projectsDocuments: 'Project documents upsell modal',
  profile: 'Profile insights upsell state',
  expenses: 'Expenses upsell banner',
  budgetSettings: 'Project budget settings upsell state',
  projectLog: 'Project log upsell state',
}
